import { SearchBox } from "../SearchBox";

export const ManualOrderHeader = ({
  search,
  onSearch,
}: {
  search: string;
  onSearch: (value: string) => void;
}) => {
  return (
    <div className="border border-[#eeeeee] p-3 rounded-[10px]">
      <div className="flex items-center justify-between">
        <span className="font-medium cursor-pointer">All Product</span>

        <div className="">
          <SearchBox
            value={search}
            onChange={onSearch}
            placeholder="Search Order ID, Customer Name"
          />
        </div>
      </div>
    </div>
  );
};
